import React from 'react';
import { Container, Col } from 'react-bootstrap';
import TopNavBar from '../Components/TopNavBar';
import ContentBlockSmall from '../Components/ContentBlockSmall';
import Footer from '../Components/Footer';
import Kursas from '../Components/Kursas';
import { Link } from 'react-router-dom';
import KursaiService from '../Api/KursaiService';


class MainPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            pageName: 'Kursai',
            kursaiList: [
            ]
        }
    }

    componentDidMount() {
        KursaiService.getKursai().then((response) => {
            this.setState({
                kursaiList: response.data
            });
        }).catch(error => {
            this.setState({
                kursaiList: []
            })
        });
    }

    render() {

        const myStyle = {
            backgroundImage: "url(/main-page-background.png)",
            width: '100vw',
            backgroundSize: 'cover',
            backgroundRepeat: 'repeat',
        };

        return (
            <Container fluid style={myStyle}>
                <TopNavBar activeRoute={0} />
                <Container>
                    <div style={{ marginTop: '10%', marginBottom: '10%', fontSize: '50px' }}>
                        <div className='main-page-title' style={{ marginLeft: '20%' }}>Maisto</div>
                        <div className='main-page-title' style={{ marginLeft: '30%' }}>gaminimo</div>
                        <div className='main-page-title' style={{ marginLeft: '40%' }}>kursai</div>
                    </div>
                    <ContentBlockSmall title={'Populiariasi kursai'}>
                        {this.state.kursaiList.slice(0,4).map((kursas, index) => {
                            var hrefString = '/kursai/' + kursas.ID;
                            return <Col key={index} xs={12} md={3} lg={3}>
                                <Link to={{ pathname: hrefString, state: { id: 100 } }} className="link-light">
                                    <Kursas Name={kursas.Name} Price={kursas.Price} Image={kursas.Files[0].Path} />
                                </Link>
                            </Col>
                        })
                        }
                    </ContentBlockSmall>
                </Container>
                <Footer></Footer>
            </Container>
        );
    }
}

export default MainPage;